<template>
  <div>
      <div class="title">
        <img src="@/assets/img/アセット 45@3x.png" />
      </div>
  </div>
</template>

<script>
export default {
  name: "Top",
  beforeCreate: function () {
    document.body.className = "top";
  },
  created() {
    if(this.$store.state.firstAccess === true) {
    const token = this.$route.query.t //token取得
    this.$cookies.set("token", token) //cookieにtoken保存
    this.fetchAddUser();
    this.$store.commit("FIRST_ACCESS", false);
    } else {
     setTimeout(this.TransitionToHome, 3000);
    }
  },
  methods: {
    //users api post処理
    fetchAddUser: async function () {
      const new_axios = this.axios.create({
        headers: {
          Authorization:
          "Bearer " + this.$cookies.get('token'),
          "Ocp-Apim-Subscription-Key": process.env.SUBSCRIPTION_KEY,
        },
        responseType: "json",
      });
      const body = {};
      const endpoint = process.env.API_ENDPOINT + "/users";
      const response = await new_axios
        .post(endpoint, body)
        .catch(function (error) {
          console.log("エラーだよ", error);
        });
        //storeにuser_name,id保存
      this.$store.commit("FETCH_ADD_USER_NAME", response.data.user_name);
      this.$store.commit("FETCH_ADD_USER_ID", response.data.id);
      setTimeout(this.TransitionToHome, 3000);
    },
    TransitionToHome() {
      this.$router.push('/home')//Home.vueへ遷移
    }
  },
};
</script>

<style>
body.top {
  background-image: url("~@/assets/img/th_アセット 1@0.5x.jpg");
  background-size: cover;
  background-repeat: no-repeat;
}
.title {
  margin-top: 200px;
}
.title img {
  width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Top.vue